// Angular Imports
import {
	AfterViewInit,
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	DestroyRef,
	OnInit,
	inject,
	signal,
} from '@angular/core'
import { NgIf, NgSwitch, NgSwitchCase, NgSwitchDefault } from '@angular/common'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
// Angular Material Imports
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog'
// Shared Imports
import { ButtonComponent, IconButtonComponent, IconComponent } from '@shared/components'
import { EIcons } from '@shared/models'
// Thirdparty Imports

const sharedComponents = [ButtonComponent, IconComponent]

@Component({
	standalone: true,
	selector: 'app-alert',
	imports: [NgIf, NgSwitch, NgSwitchCase, NgSwitchDefault, MatDialogModule, ...sharedComponents],
	templateUrl: './alert.component.html',
	styleUrls: ['./alert.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertComponent implements OnInit, AfterViewInit {
	readonly #destroyRef = inject(DestroyRef)
	readonly #cdr = inject(ChangeDetectorRef)
	readonly #dialogRef = inject(MatDialogRef<AlertComponent>)
	readonly #dialogData: IDialogData = inject(MAT_DIALOG_DATA)
	readonly EIcons = EIcons
	readonly EAlertType = EAlertType

	dialogData = signal<IDialogData>({
		type: EAlertType.success,
		message: '-',
		successButtonText: '-',
		hasCancelButton: false,
	})

	ngOnInit(): void {
		this.#dialogRef
			.backdropClick()
			.pipe(takeUntilDestroyed(this.#destroyRef))
			.subscribe({
				next: () => {
					this.onCloseDialog({ isSuccess: false })
				},
			})
	}

	ngAfterViewInit(): void {
		this.dialogData.set(this.#dialogData)
		this.#cdr.detectChanges()
	}

	onCloseDialog({ isSuccess = false }: { isSuccess: boolean }): void {
		this.#dialogRef.close({ isSuccess })
	}
}

enum EAlertType {
	success = 'success',
	error = 'error',
	warning = 'warning',
	info = 'info',
}

interface IDialogData {
	type: keyof typeof EAlertType
	message: string
	successButtonText?: string
	hasCancelButton?: boolean
}
